import React from 'react';
import { IRestaurantBankSettings } from 'types';
import { BankSettingFields } from './components/BankSettingFields';
import style from './BankSettingsBlock.module.scss';

interface IProps {
	bankSettings: IRestaurantBankSettings[];
}

const BankSettingsBlock: React.FC<IProps> = ({ bankSettings }) => {
	return (
		<div className={style.container}>
			{bankSettings.length ? (
				bankSettings.map((bankSetting) => <BankSettingFields key={bankSetting.id} bankSetting={bankSetting} />)
			) : (
				<div />
			)}
		</div>
	);
};

export default BankSettingsBlock;
